// Confirmación antes de borrar. El botón rojo es el que ejecuta.
const ConfirmDeleteModal = ({ onConfirm, onCancel, message }) => (
  <div className="modal-overlay">
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h2>Confirmar Eliminación</h2>
      <p>{message}</p>
      <div className="modal-actions">
        <button className="btn-cancel" onClick={onCancel}>
          Cancelar
        </button>
        <button className="btn-delete" onClick={onConfirm}>
          Sí, Eliminar
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmDeleteModal;
